import React, { useState } from 'react';
import { Filter } from 'lucide-react';
import { galleryImages } from '../mockData';
import { Button } from './ui/button';

const Gallery = () => {
  const [filter, setFilter] = useState('all');

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter || img.category === 'both');

  return (
    <section id="gallery" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#8B9E8A] mb-4">
            Galerie Photos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez mes prestations en images
          </p>
        </div>

        {/* Filter Buttons */}
        <div className="flex justify-center gap-4 mb-12 flex-wrap">
          <Button
            onClick={() => setFilter('all')}
            className={`rounded-full px-6 py-2 font-semibold transition-all duration-300 ${
              filter === 'all'
                ? 'bg-gradient-to-r from-[#8B9E8A] to-[#9CAF88] text-white'
                : 'bg-white text-[#8B9E8A] border-2 border-[#8B9E8A]/20 hover:border-[#C5A572]'
            }`}
          >
            Toutes
          </Button>
          <Button
            onClick={() => setFilter('equin')}
            className={`rounded-full px-6 py-2 font-semibold transition-all duration-300 ${
              filter === 'equin'
                ? 'bg-gradient-to-r from-[#8B9E8A] to-[#9CAF88] text-white'
                : 'bg-white text-[#8B9E8A] border-2 border-[#8B9E8A]/20 hover:border-[#C5A572]'
            }`}
          >
            🐴 Équin
          </Button>
          <Button
            onClick={() => setFilter('canin')}
            className={`rounded-full px-6 py-2 font-semibold transition-all duration-300 ${
              filter === 'canin'
                ? 'bg-gradient-to-r from-[#8B9E8A] to-[#9CAF88] text-white'
                : 'bg-white text-[#8B9E8A] border-2 border-[#8B9E8A]/20 hover:border-[#C5A572]'
            }`}
          >
            🐕 Canin
          </Button>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredImages.map((image, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 aspect-square"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
